<template>
<div>
  <div class="sm:w-[512px] mx-auto my-auto rounded-lg flex flex-col shadow-2xl bg-white">
    <div class="py-14 px-5 rounded-t-lg bg-center bg-cover text-white"
        :class="useRedTheme ? 'bg-red-primary' : 'bg-blue-900'"
      :style="bgImgPath ? `background-image: url(${bgImgPath})` : ''">
      <div class="text-6xl font-bold text-center pb-4 shadow-black"
          :class="useRedTheme && !bgImgPath 
                  ? 'text-red-secondary text-shadow-md'
                  : 'text-white text-shadow-xl'">
          <slot name="h1"></slot>
      </div>
      <div class="text-xl font-semibold text-center text-shadow-2xl shadow-black">
          <slot name="h2"></slot>
      </div>
    </div>
    <div class="pt-10 px-5 flex flex-col">
      <PrimaryButton
          @click="onClick"
          id="login-button"
          class="pb-8 sm:mx-10 flex items-center justify-center" 
          :colorClass="`shadow-md shadow-gray-700 active:shadow-gray-700 active:shadow-sm 
              ${ useRedTheme ? 'bg-red-primary hover:bg-red-primary/95' : 'bg-blue-800 hover:bg-blue-900'}`">
          <span class="pointer-events-none text-xl mx-12"
               :class="useRedTheme ? 'text-red-secondary' : 'text-white'">
            Sign in
          </span>
      </PrimaryButton>
      <div class="text-md font-semibold text-center"
          :class="useRedTheme ? 'text-red-primary' : 'text-slate-900'">
        <slot name="h3"></slot>
      </div>
      <div class="pb-10 text-slate-800 sm:flex hidden text-md
                  font-light content-center flex-col mx-auto">
          <slot>Copyright (C) {{ thisYear }} RED Engineering Design Ltd</slot>
      </div>
    </div>

  </div>
</div>
</template>
<script setup>
import { useComponentError } from "../composables/error.js";
import PrimaryButton         from './PrimaryButton.vue';

const props = defineProps({
  redirectUrl: { type: String, required: true, },
  bgImgPath: { type: String, default: null, },
  useRedTheme: { type: Boolean, default: false, },
  authClient: { type: Object, required: true, },
  // Dependency injection
  set_window_location: { type: Function, default: window.location.assign.bind(window.location), },
  thisYear: { type: Number, default: new Date().getFullYear(), }
});

const emit = defineEmits([ 'error' ]);
const { on_error, catcher } = useComponentError({emit});
function onClick() { 
  catcher("LoginElement::onClick", () => {
    props.authClient.isAuthenticated(props.redirectUrl)
        .then(() => {
          props.set_window_location(props.redirectUrl);
        })
        .catch((e) => {
          on_error({msg: "Error in LoginElement::onClick::isAuthenticated", e});
        });
  });
}
</script>
  
